export default __webpack_public_path__ + "static/O0052-2aba3757db4eb5a370e968b1c9cd9be5.png";